import {
  TASK_LOOKUP_PENDING,
  TASK_LOOKUP_SUCCESS,
  TASK_LOOKUP_FAIL,
}  from "../../../actions/types";

const initialState = {
  taskLookups: {},
  taskLookupLoading: false,
  error: null,
};

const taskLookupReducer = (state = initialState, action) => {
  switch (action.type) {
    case TASK_LOOKUP_PENDING:
      return {
        ...state,
        taskLookupLoading: true,
        error: null,
      };

    case TASK_LOOKUP_SUCCESS:
      return {
        ...state,
        taskLookups: action.payload.lookups,
        taskLookupLoading: false,
        error: null,
      };

    case TASK_LOOKUP_FAIL:
      return {
        ...state,
        taskLookupLoading: false,
        error: "Failed to fetch task lookup data",
      };

    default:
      return state;
  }
};

export default taskLookupReducer;
